export const configuration = {
    isShowMarketing: true,
    apiKeyMap: 'AIzaSyASJk1hzLv6Xoj0fRsYnfuO6ptOXu0fZsc',
}

export const OrderType = {
    ORDER_TYPE_PICK_UP: 'PICK_UP',
    ORDER_TYPE_DELIVERY: 'DELIVERY',
    ORDER_TYPE_DELIVERY_FUEL: 'DELIVERY_FUEL',
    ORDER_TYPE_PICK_UP_CAR: 'PICK_UP_CAR',
}

export var configData = {
    //HWS set to false for GOOGLE
    huawei: false, //set to false to go back to Google
    showPage: false,
    showTabVoucher: false,//show/hide tab My Voucher in page gift-catalog
    onAddGift: false,//only view gift don't add gift
    Configuration:
    {
        social_type:'icon',
        transaction_show_detail : true,
        transaction_tab:
        {
            awards : true,
            spends: true,
            purchase : true,
        },
        transaction_month:[1,6,12],
        showPoint:true,
        point_currency:"P",
        loginType:'phone',
        registerType:'phone',
        apiVersion:'v3',
        isShowMarketing:false,
        apiKey:'AIzaSyBqME4lXZZREOpE4NCFuVNaj9I4qWfN2v0',
        tookanUserId:'445685'
    },
    physical_goods:[
        {label:"SIM & NEW Router",value:'simAndRouter'},
        {label:"SIM & Certified Pre-owned Router",value:'simandrefurbishedrouter'},
        {label:"SIM & FREE to use Router",value:'freeToUseRouter'},
        {label:"SIM only (supply your own LTE router)",value:'sim'},
    ]
}